export default "__VITE_ASSET__7Wl_3pZ$__"